/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface AiLogItem {
  id: number
  user_id: number | null
  action_type: string
  prompt_code?: string | null
  prompt?: string | null
  model: string
  token_input: number
  token_output: number
  cost: number | string
  latency_ms?: number | null
  is_success?: number | boolean
  error_message?: string | null
  user_agent?: string | null
  ip_address?: string | null
  ai_output?: string | null
  created_at: string
  user?: {
    id: number
    name: string
    email: string
    username: string
    avatar?: string
    is_test?: number
  } | null
}

export interface AiLogQueryParams extends Partial<PageQueryParams> {
  limit?: number
  action_type?: string
  model?: string
  is_success?: number | boolean | string
  search?: string
  start_date?: string
  end_date?: string
}

export interface AiLogListResponse {
  code: number
  data: AiLogItem[]
  total: number
  page: number
  limit: number
}

export const aiLogService = {
  list(params: AiLogQueryParams) {
    return HttpRequest.get("v1/ai-logs", {
      searchParams: params as any,
    }).json<AiLogListResponse>()
  },

  getModels() {
    return HttpRequest.get("v1/ai-logs/models").json<{
      code: number
      data: string[]
    }>()
  },
}
